import { render } from "./NewCreateResellerPage.vue?vue&type=template&id=5c71c4d2"
import script from "./NewCreateResellerPage.vue?vue&type=script&lang=js"
export * from "./NewCreateResellerPage.vue?vue&type=script&lang=js"

import "./NewCreateResellerPage.vue?vue&type=style&index=0&id=5c71c4d2&lang=css"

import exportComponent from "/opt/1psim/portal_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__